import { IRuleMapping } from "./interfaces";
import { findBandMapping, findMapping } from "./findMapping";
import { calculateCharge } from "./calculateCharge";
import { IStampDutyCountry } from "../forms/types";
import { mappings } from "./mappings";
import { additionalChargeRules, IAdditionalChargeRule } from "./additionalChargeRules";

export interface ICalculateStampDutyParams {
  propertyValue: number;
  country: IStampDutyCountry;
  isFirstTimeBuyer: boolean;
  isOnlyProperty: boolean;
}

export const calculateStampDuty = (
  context: ICalculateStampDutyParams,
): number => {
  const { propertyValue } = context;

  const appropriateMapping: IRuleMapping | undefined = findBandMapping(
    {
      ...context
    },
    mappings
  );

  if (!appropriateMapping) {
    throw new Error("Could not find rules.");
  }

  const bands = appropriateMapping[1];

  const additionalChargeRule = findMapping(context, additionalChargeRules) as
    | IAdditionalChargeRule
    | undefined;

  return calculateCharge(
    bands,
    additionalChargeRule,
    propertyValue!,
  );
};
